export default "__VITE_ASSET__b8bef8e8__"